
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collaborations",
      function () {
        return require("private-next-pages/collaborations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collaborations"])
      });
    }
  